var _defs, _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g3, _g4, _g5, _g6, _path14, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgWellDoneV3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 266,
    height: 233.635,
    viewBox: "0 0 266 233.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1146",
    "data-name": "Rectangle 1146",
    width: 153.681,
    height: 171.268,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21991",
    "data-name": "Path 21991",
    d: "M15.84,46.568C6.232,52.522,5.425,55.085,5.425,55.085l20.786,4.073L64.648,53.63l5.067-12.323s-.911-.01-2.5-.01c-9.528,0-43.437.351-51.374,5.271",
    transform: "translate(-5.425 -41.297)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.119,
    y1: 2.663,
    x2: -0.096,
    y2: 2.663,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9cda2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eabc92"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21992",
    "data-name": "Path 21992",
    d: "M60.5,126.058s-21.463,11.957-.677,11.362c26.777-.764,33.2-40.493,33.2-40.493C95.489,53.712,71.387,43.38,71.387,43.38Z",
    transform: "translate(-50.759 -43.38)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1.124,
    y1: 1.131,
    x2: -1.098,
    y2: 1.131,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1141",
    "data-name": "Rectangle 1141",
    width: 57.764,
    height: 10.806,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1142",
    "data-name": "Rectangle 1142",
    width: 12.488,
    height: 33.068,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1143",
    "data-name": "Rectangle 1143",
    width: 9.032,
    height: 16.58,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1144",
    "data-name": "Rectangle 1144",
    width: 5.359,
    height: 16.58,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20cafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cf0fe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "img_well_done",
    transform: "translate(-64 -354.365)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22010",
    "data-name": "Path 22010",
    d: "M202.358,172.971A101.179,101.179,0,1,1,101.179,71.792,101.179,101.179,0,0,1,202.358,172.971",
    transform: "translate(95 300.027)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(119.66 354.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_253-2",
    "data-name": "Group 253",
    transform: "translate(8.035 61.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1139",
    "data-name": "Rectangle 1139",
    width: 64.9,
    height: 46.754,
    transform: "translate(-7.566 4.187) rotate(-28.957)",
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(75.181 64.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1140",
    "data-name": "Rectangle 1140",
    width: 56.45,
    height: 94.635,
    transform: "translate(-11.72 0)",
    fill: "url(#linear-gradient-2)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    clipPath: "url(#clip-path)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21993",
    "data-name": "Path 21993",
    d: "M67.594,42.642C79.361,30.553,87.5,58.687,86.324,90.65S70.276,143.109,51.175,143.2c-17.249.084.079-31.7,1.569-48.942,1.64-18.978,3.144-39.591,14.85-51.617",
    transform: "translate(20.969 19.139)",
    fill: "#f9cda2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21994",
    "data-name": "Path 21994",
    d: "M60.4,0C71.774,0,80.372,14.251,79.331,42.461S76.137,82.046,57.04,82.046c-17.245,0-12.681-21.33-11.267-36.544C47.331,28.755,43.618,0,60.4,0",
    transform: "translate(21.247 0)",
    fill: "#f9cda2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21995",
    "data-name": "Path 21995",
    d: "M78.893,109.787c0,9.216-11.043,16.685-32.025,16.685S12.458,119,12.458,109.787,25.887,93.1,46.868,93.1c27.459,0,32.025,7.468,32.025,16.682",
    transform: "translate(5.994 44.796)",
    fill: "#eabc92"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21996",
    "data-name": "Path 21996",
    d: "M79.855,106.977c0,8.094-11.043,19.1-32.025,19.1s-37.372-4.443-37.372-19.1c0-8.1,16.392-14.656,37.372-14.656,27.459,0,32.025,6.56,32.025,14.656",
    transform: "translate(5.032 44.418)",
    fill: "#f9cda2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21997",
    "data-name": "Path 21997",
    d: "M86.981,96.591c0,10.608-12.72,19.209-36.886,19.209s-39.638-8.6-39.638-19.209S25.926,77.381,50.1,77.381c31.627,0,36.886,8.6,36.886,19.21",
    transform: "translate(5.031 37.23)",
    fill: "#eabc92"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21998",
    "data-name": "Path 21998",
    d: "M89.088,95.2c0,9.875-15.047,17.879-43.639,17.879S3,105.075,3,95.2C3,80.07,16.856,77.322,45.449,77.322c37.418,0,43.639,8,43.639,17.879",
    transform: "translate(1.443 37.202)",
    fill: "#f9cda2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21999",
    "data-name": "Path 21999",
    d: "M90.921,80.246c0,11.311-13.714,20.481-39.767,20.481S8.425,91.557,8.425,80.246,25.1,59.765,51.154,59.765c34.1,0,39.767,9.17,39.767,20.481",
    transform: "translate(4.054 28.755)",
    fill: "#eabc92"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22000",
    "data-name": "Path 22000",
    d: "M93.493,79.15c0,10.645-16.326,19.274-47.346,19.274S0,89.794,0,79.15C0,62.836,15.13,58.393,46.148,58.393c40.593,0,47.346,10.112,47.346,20.757",
    transform: "translate(0 28.095)",
    fill: "#f9cda2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22001",
    "data-name": "Path 22001",
    d: "M89.4,62.655c0,10.645-15.195,19.275-41.248,19.275S5.425,73.3,5.425,62.655,22.1,43.38,48.154,43.38,89.4,52.011,89.4,62.655",
    transform: "translate(2.61 20.871)",
    fill: "#eabc92"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22002",
    "data-name": "Path 22002",
    d: "M88.4,59.693c0,10.645-15.195,19.275-41.248,19.275S4.425,70.338,4.425,59.693,21.1,43.38,47.154,43.38,88.4,49.048,88.4,59.693",
    transform: "translate(2.129 20.871)",
    fill: "#f9cda2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22003",
    "data-name": "Path 22003",
    d: "M57.249,1.171a8.586,8.586,0,0,1,4.064,1.253,13.764,13.764,0,0,1,3.334,2.709,24.349,24.349,0,0,1,4.488,7.272A52.326,52.326,0,0,1,72.75,28.951c.4,5.633.326,11.257.267,16.875-.129,5.615-.29,11.243-.779,16.848l-.095-.392a59.15,59.15,0,0,1,5.294,10.8,66.08,66.08,0,0,1,3.181,11.578,61.227,61.227,0,0,1,.914,11.96c-.056,2-.221,3.993-.468,5.972-.277,1.976-.661,3.932-1.13,5.864l-.144-.03a68.452,68.452,0,0,0,.678-11.8,69.207,69.207,0,0,0-1.32-11.688A76.213,76.213,0,0,0,76.009,73.6a64.178,64.178,0,0,0-4.882-10.661l-.117-.2.022-.191c.655-5.559,1.3-11.134,1.483-16.737a97.893,97.893,0,0,0-.766-16.759,73.693,73.693,0,0,0-3.712-16.2,27.01,27.01,0,0,0-4.018-7.167c-1.74-2.065-4-3.94-6.773-4.363Z",
    transform: "translate(27.543 0.563)",
    fill: "#eabc92"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22004",
    "data-name": "Path 22004",
    d: "M57.246,118.5A36.5,36.5,0,0,0,68.3,114.378a20.33,20.33,0,0,0,4.806-3.454,16.82,16.82,0,0,0,3.31-4.931,37.136,37.136,0,0,0,2.894-11.418,94.88,94.88,0,0,0,.475-11.957l.148-.018a38.01,38.01,0,0,1,.948,12.136,27.056,27.056,0,0,1-3.752,11.639,35.555,35.555,0,0,1-3.673,4.874,25.541,25.541,0,0,1-4.507,4.177,19.14,19.14,0,0,1-5.618,2.542,17.941,17.941,0,0,1-6.084.678Z",
    transform: "translate(27.543 39.741)",
    fill: "#eabc92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(10.06 65.877)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22005",
    "data-name": "Path 22005",
    d: "M6.792,55.283a15.209,15.209,0,0,1,5.491-5.219A34,34,0,0,1,19.3,46.989a59.43,59.43,0,0,1,15.07-2.435,100.854,100.854,0,0,1,15.213.564q3.779.424,7.529,1.025c2.491.449,4.98.9,7.441,1.487-2.518-.253-5.021-.563-7.536-.766-2.508-.255-5.018-.467-7.53-.612a144.23,144.23,0,0,0-15.051-.219A70.794,70.794,0,0,0,19.62,48.079a33.759,33.759,0,0,0-6.985,2.614,15.969,15.969,0,0,0-5.843,4.59",
    transform: "translate(-6.792 -44.477)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(69.407 2.636)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22006",
    "data-name": "Path 22006",
    d: "M59.349,2.017a5.732,5.732,0,0,0-4.331,1.354,10.841,10.841,0,0,0-2.833,3.59,33.525,33.525,0,0,0-2.85,8.909c-.624,3.093-.981,6.25-1.311,9.416-.167,1.585-.29,3.176-.4,4.769l-.375,4.794a72.36,72.36,0,0,1-.366-9.633,57.6,57.6,0,0,1,1-9.633A27.775,27.775,0,0,1,51.2,6.394,11.548,11.548,0,0,1,54.6,2.78a5.736,5.736,0,0,1,4.746-.763",
    transform: "translate(-46.861 -1.78)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(3.446 94.703)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22007",
    "data-name": "Path 22007",
    d: "M11.359,63.94a12.12,12.12,0,0,0-7.426,6.511C2.585,73.56,2.757,77.116,3.324,80.52a17.354,17.354,0,0,1-.986-5.141,12.08,12.08,0,0,1,.915-5.221A10.221,10.221,0,0,1,6.551,66a10.9,10.9,0,0,1,4.808-2.057",
    transform: "translate(-2.327 -63.939)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(6.972 122.35)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22008",
    "data-name": "Path 22008",
    d: "M10.066,82.606a7.9,7.9,0,0,0-3.25,3.139,10.775,10.775,0,0,0-1.3,4.294,28.744,28.744,0,0,0,.96,9.147A21.959,21.959,0,0,1,5.055,94.7a15.835,15.835,0,0,1-.278-4.741,9.793,9.793,0,0,1,1.558-4.517,6.869,6.869,0,0,1,3.731-2.838",
    transform: "translate(-4.707 -82.606)",
    fill: "#fff"
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22009",
    "data-name": "Path 22009",
    d: "M73.516,48.184s29.137,41.546,1.336,81.766L113.3,118.82C114.483,100.957,130.985,63,96.774,42.3Z",
    transform: "translate(35.371 20.35)",
    fill: "#49a8fb"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1243",
    "data-name": "Rectangle 1243",
    width: 266,
    height: 45,
    rx: 22.5,
    transform: "translate(64 543)",
    fill: "url(#linear-gradient-3)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgWellDoneV3);
export default __webpack_public_path__ + "static/media/img_well_done_v3.9e1086c60831bf768daa731401df8bba.svg";
export { ForwardRef as ReactComponent };